<template>
    <b-container fluid>
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
        <div class="Info_Area">
            <b-row>
                <b-col cols="12">
                    <b-row>
                        <b-col cols="auto">
                            <h2 class="mb-3">介接歷程</h2>
                        </b-col>
                    </b-row>
                    <b-row></b-row>
                    <b-row class="mb-2">
                        <b-col cols="12">
                            <div class="alert alert-info">
                                <span class="link" @click="switchIframe('1')">農產品交易行情</span>
                                <span class="link" @click="switchIframe('2')">今明天氣預報</span>
                                <span class="link" @click="switchIframe('3')">測站資料</span>
                                <span class="link" @click="switchIframe('4')">鄉鎮天氣預報</span>
                                <span class="link" @click="switchIframe('5')">雨量觀測資料</span>
                                <span class="link" @click="switchIframe('6')">颱風警報</span>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="12">
                    <iframe :src="iframeUrl" style="width: 100%; height: 650px;" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"></iframe>
                </b-col>
            </b-row>
        </div>
    </b-container>
</template>
<script>
    export default {
        data() {
            return {
                breadcrumbItems: [{
                        text: '首頁',
                        href: '#'
                    },
                    {
                        text: '資料建置',
                        active: true
                    },
                    {
                        text: '介接歷程',
                        active: true
                    }
                ],
                iframeUrl: ""
            }
        },
        mounted() {
            this.checkLogin()
        },
        methods: {
            checkLogin() {
                this.checkPermission()
            },
            async checkPermission()
            {
                let accountdata = {PJ_ID: 'PJ000000000022', fun:this.checkshowByPJID}
                this.FunctionToken(this.Authority, accountdata)
            },
            checkshowByPJID(value){
                if(!value)
                {
                    alert("無權限檢視此頁面，將返回首頁")
                    this.$router.push({ path: '/' })
                }
                else
                {
                    let TokenID = encodeURIComponent(sessionStorage.getItem("TokenID"));
                    this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=21&NAME=%E8%BE%B2%E7%94%A2%E5%93%81%E4%BA%A4%E6%98%93%E8%A1%8C%E6%83%85&WORK_TYPE=&token=" + TokenID; // 農產品交易行情
                }
            },
            switchIframe(value){
                let TokenID = encodeURIComponent(sessionStorage.getItem("TokenID"));
                switch (value) {
                    case '1':
                        this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=21&NAME=%E8%BE%B2%E7%94%A2%E5%93%81%E4%BA%A4%E6%98%93%E8%A1%8C%E6%83%85&WORK_TYPE=&token=" + TokenID; // 農產品交易行情
                        break;
                    case '2':
                        this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=6&NAME=%E9%84%89%E9%8E%AE%E9%A0%90%E5%A0%B1&WORK_TYPE=&token=" + TokenID; // 今明天氣預報
                        break;
                    case '3':
                        this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=13&NAME=%E4%B8%AD%E5%A4%AE%E6%B0%A3%E8%B1%A1%E5%B1%80%E6%B0%A3%E5%80%99%E8%B3%87%E6%96%99%E6%8E%A5%E6%94%B6&WORK_TYPE=&token=" + TokenID; // 測站資料
                        break;
                    case '4':
                        this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=6&NAME=%E9%84%89%E9%8E%AE%E9%A0%90%E5%A0%B1&WORK_TYPE=&token=" + TokenID; // 鄉鎮天氣預報
                        break;
                    case '5':
                        this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=4&NAME=%E9%9B%A8%E9%87%8F%E8%A7%80%E6%B8%AC%E8%B3%87%E6%96%99&WORK_TYPE=&token=" + TokenID; // 雨量觀測資料
                        break;
                    case '6':
                        this.iframeUrl = "/Yunlin/Transfer/DataTransferWeb/RECEIVELog.aspx?SN=9&NAME=%E9%A2%B1%E9%A2%A8%E8%AD%A6%E5%A0%B1&WORK_TYPE=&token=" + TokenID; // 颱風警報
                        break;
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
.link {
  cursor: pointer;
  transition: .2s all linear;
  &:hover{
    opacity: .8;
  }
  &:not(:last-child){
      margin-right: 1rem;
  }
}
</style>